import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import { makeStyles } from "@material-ui/core/styles";
import { createMuiTheme, Slide, Container, Dialog, Toolbar, Typography, Fab, CssBaseline, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import '../../../css/react-bootstrap-table2.css';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { Context } from "../../contexts/siteContext";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import AddUnit from "../unit/unitAdd";
import UnitLocation from "../unit/unitLocation";
import AlertDialog from '../../common/alertDialog';
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function UnitList(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [unitOpen, setUnitOpen] = useState(false);
    const [unitLocationOpen, setUnitLocationOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [id, setId] = useState();
    const [units, setUnits] = useState([]);
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [recordToLocation, setRecordToLocation] = useState([]);
    const [backDrop, setBackDrop] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (row, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const alertClose = () => {
        setAlertOpen(false);
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };
    
    const getUnits = () => {
        setBackDrop(true);
        HttpService.post('/Unit/GetUnits', { SiteCode: defaultSite.id })
            .then((result) => {
                setUnits(result.data);
                setBackDrop(false);
            },
                (error) => {
                    setBackDrop(false);
                    console.log(error);
                });
    };

    const addUnit = () => {
        setUnitOpen(true);
        setRecordToBeEdit([]);
    };

    const editUnit = (row) => {
        setUnitOpen(true);
        setRecordToBeEdit(row);
    };

    const updateList = (item) => {
        const data = units;
        const index = data.findIndex(data => data.Id === item.Id);
        if (index === -1)
            data.push(item);
        else
            data[index].UnitName = item.UnitName;
        setUnits(data);
    };

    const deleteUnitConfirm = (id) => {
        setConfirmOpen(true);
        setId(id);
    };

    const deleteUnit = () => {
        setConfirmOpen(false);
        HttpService.post('/Unit/DeleteUnit', { Id: id })
            .then((result) => {
                if (result.error) {
                    setErrorMessage(result.message);
                    setSeverity('error');
                    setAlertOpen(true);
                }
                else {
                    const data = units.filter(units => units.Id !== id);
                    setUnits(data);
                }
            },
                (error) => {
                    console.log(error);
                });
    };

    const listUnitLocations = (row) => {
        setRecordToLocation(row);
        setUnitLocationOpen(true);
    };

    const handleClose = () => {
        setUnitOpen(false);
    };

    const handleUnitLocationClose = () => {
        setUnitLocationOpen(false);
    };

    useEffect(() => {
        getUnits();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        const columns = [
            {
                dataField: 'Id',
                text: 'ID',
                hidden: true,
            },
            {
                dataField: 'rowNumber',
                text: '#',
                formatter: (cellContent, row, index) => { return (<div>{index + 1}</div>); },
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground,
                    width: '50px'
                }
            },
            {
                dataField: 'UnitName',
                text: 'Unit Name',
                sort: true,
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                }
            },
            {
                dataField: 'SiteName',
                text: 'Site Name',
                sort: true,
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                }
            },
            {
                dataField: 'df2',
                text: '',
                isDummyField: true,
                headerStyle: {
                    width: '90px',
                    background: currentTheme.headerBackground
                },
                formatter: (cellContent, row) => {
                    return (<div style={{ display: 'flex' }}>
                        <EditIcon style={{ color: currentTheme.secondary, cursor: 'pointer'}} onClick={() => { editUnit(row); }} />
                        <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => deleteUnitConfirm(row.Id)} />
                        <LocationOnIcon style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => listUnitLocations(row)} />
                    </div>
                    );
                }
            }
        ];
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="unitListBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={unitOpen} onClose={handleClose} TransitionComponent={Transition}>
                        <AddUnit parentCallback={handleClose}
                            refreshGrid={updateList}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={unitLocationOpen} onClose={handleUnitLocationClose} TransitionComponent={Transition}>
                        <UnitLocation parentCallback={handleUnitLocationClose}
                            model={recordToLocation}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link to="/"><KeyboardBackspaceIcon /></Link>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>&nbsp;Units</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={addUnit}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <BootstrapTable bootstrap4 rowStyle={rowStyle} keyField='Id' data={units} columns={columns} hover noDataIndication="No records found" />
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteUnit}
                                    title="Delete Unit" message="Are you sure you want to delete the selected Unit?" />
                                <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }
    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
